import { Descriptions, Row } from "antd";
import getAtribute from "../../../utils/getAtribute";
import phoneMask from "../../../utils/getPhoneMask";

export function DetailsHigher({ entidade }) {
  const timeFormmatted = entidade.dataAtualizacaoChefeImediato
    ? `${new Date(entidade.dataAtualizacaoChefeImediato).toLocaleString()}`
    : "";

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Chefe Imediato</div>
      </Row>
      <Descriptions>
        <Descriptions.Item label="Nome">
          {getAtribute(entidade, "chefeImediato")}
        </Descriptions.Item>
        <Descriptions.Item label="Matricula">
          {getAtribute(entidade, "matriculaChefeImediato")}
        </Descriptions.Item>
        <Descriptions.Item label="Telefone">
          {phoneMask(getAtribute(entidade, "telefoneChefeImediato"))}
        </Descriptions.Item>
        <Descriptions.Item label="Observação">
          {getAtribute(entidade, "obsChefeImediato")}
        </Descriptions.Item>
        <Descriptions.Item label="Data">{timeFormmatted}</Descriptions.Item>
      </Descriptions>
      <div className="divider" />
    </>
  );
}
